export default __webpack_public_path__ + "static/media/LR.367719d1.svg";